<script>
import {Routes} from '@/router'

export default {
  computed: {
    child_routes() {
      // Returns all child routes for this doc viewer
      const parent_route = this.$router.options.routes
        .filter(r => r.name === Routes.Dashboard.name)
      const routes = parent_route[0].children
        .filter(r => r.name === Routes.Docs.name)
      return routes[0].children
    },
    index() {
      // Returns either the index route or the first route from child_routes
      return (
        this.child_routes.filter(r => r.name === `${this.route_name}-index`)[0]
          || this.child_routes[0]
      )
    },
    tab_links() {
      // Returns a list of child route links, but excludes the index route
      return this.child_routes.filter(p => p.path !== 'index')
    },
    page_links() {
      return this.tab_links.reduce((acc, route) => {
        acc[route.name] = (route.children || []).filter(c => c.path !== 'index')
        return acc
      }, {})
    }
  },
  mounted() {
    if(this.$route.name === Routes.Docs.name) {
      this.$router.push(Routes.QuickStartDoc)
    }
  },
  name: 'candela-docs',
  watch: {
    $route() {
      const container = this.$refs.container
      container.scrollTop = 0
    }
  }
}
</script>

<template>
<div class='candela-docs-container'>
  <div class='d-flex align-center justify-space-between'>
    <v-toolbar>
      <v-tabs class='mr-2' color='secondary'>
        <v-menu v-for='(link, i) in tab_links' :key='i'
          :disabled='page_links[link.name].length === 0'
          :close-on-content-click='false'
          transition='scroll-y-transition'
          open-on-hover bottom offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-tab
              v-bind='attrs' v-on='on'
              :to='{name: link.name}' v-text='link.path'/>
          </template>
          <v-list color='secondary' dense>
            <v-list-item v-for='(page, j) in page_links[link.name]' :key='j'
              :to='page'>
              <v-list-item-title>{{page.props.data.title}}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-tabs>
    </v-toolbar>
  </div>
  <div ref='container' class='doc-viewer-container pa-8 overflow-auto'>
    <router-view/>
  </div>
</div>
</template>

<style lang='sass' scoped>
.candela-docs-container
  height: calc(100vh - 64px)

.doc-viewer-container
  height: calc(100vh - 128px)

.theme--light
  color: var(--v-grey-base)

.theme--dark
  color: var(--v-grey-darken3)

.v-toolbar
  z-index: 1
</style>
